import { httpPost } from '../../../../common/util'

export const submitGame = (firstName, lastName, email, gameName, gameDescription, gameBuildLink) => {
    return httpPost({
        url: '/web/info/submit',
        dataType: 'json',
        data: {
            firstName,
            lastName,
            email,
            gameName,
            gameDescription,
            gameBuildLink
        }
    })
}